import { api } from "../../api/fetch";

export const fetchTestSuites = async () => {
    return await api.get('/api/v1/test-suites');
}

export const fetchTestSuiteFields = async (testSuiteId: number) => {
    return await api.get(`/api/v1/test-suites/${testSuiteId}/settings`);
}
